import React, { Fragment, useContext } from "react";
import { Link } from "react-router-dom";
import ChatAppContext from "../../../Chat";
import SearchChatList from "../../Recruiter/Chat/SearchChatList";
import avatar from "../../../assets/images/avatar.png";
import { capitalize } from "../../Common/CommonFunction";
import Spinner from "../../Common/Spinner";

const ChatStatus = () => {
  const { members = [], memberLoading, changeChat, searchKeyword = "", selectedUser } =
    useContext(ChatAppContext) || {};

  const filteredMembers = members.filter((member) => {
    const label = (
      member.admin_chat_title ||
      member.jobseeker_full_name ||
      member.recruiter_full_name ||
      ""
    )
      .toString()
      .toLowerCase();
    return label.includes((searchKeyword || "").toLowerCase());
  });

  const handleChatChange = (member) => {
    changeChat(member);
    member.unread_msg_count = 0;
  };

  return (
    <Fragment>
      <div className="chat-box">
        <div className="chat-left-aside">
          <div className="people-list" id="people-list">
            <SearchChatList />
            {memberLoading ? (
              <Spinner />
            ) : filteredMembers.length > 0 ? (
              <ul className="simple-list list custom-scrollbar">
                {filteredMembers.map((member) => {
                  const {
                    chat_id,
                    jobseeker_photo,
                    admin_chat_title,
                    jobseeker_full_name,
                    recruiter_full_name,
                    status,
                    ticket_status,
                    unread_msg_count,
                  } = member;
                  const isSupport = member?.chat_type === "support";
                  const title =
                    admin_chat_title ||
                    [jobseeker_full_name, recruiter_full_name]
                      .filter(Boolean)
                      .join(" ↔ ");
                  const supportStatus = ticket_status || "Chat";
                  const supportStatusClass = `status-${
                    (ticket_status || "unknown").toString().toLowerCase().replace(/_/g, '-')
                  }`;
                  const rowImg = isSupport
                    ? (member?.seeker_id ?? 0) > 0
                      ? jobseeker_photo || avatar
                      : member?.profile_image || avatar
                    : jobseeker_photo || avatar;
                  return (
                    <li
                      className={`clearfix border-0 ${
                        member?.chat_id === selectedUser?.chat_id ? "active" : ""
                      }`}
                      key={chat_id}
                    >
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleChatChange(member);
                        }}
                        style={{
                          textDecoration: "none",
                          color: "inherit",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={rowImg}
                            className="rounded-circle user-image"
                            alt=""
                          />
                          <div className="about">
                            <div className="name">
                              {capitalize(title)}
                              {isSupport ? (
                                <span className={`badge ms-1 f-11 ${supportStatusClass}`}>
                                  {supportStatus}
                                </span>
                              ) : null}
                            </div>
                            <div className="status">{status}</div>
                          </div>
                        </div>
                        {unread_msg_count !== 0 && (
                          <span className="badge rounded-pill badge-success me-3">
                            {unread_msg_count}
                          </span>
                        )}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            ) : (
              <div className="no-results">
                <p>No conversations yet</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ChatStatus;
